import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Data } from '@angular/router';
import { IError } from '../error-handler.service';
import { GoogleAnalyticsService } from '../google-analytics-service';


interface IData extends Data {
  error?: IError;
}

@Component({
  selector: 'app-error-page',
  templateUrl: './error-page.component.html',
  styleUrls: ['./error-page.component.scss']
})
export class ErrorPageComponent implements OnInit {

  public errorMessage: string = "";
  public retryUrl: string = "/";

  constructor(private route: ActivatedRoute, private googleAnalyticsService: GoogleAnalyticsService) { }

  ngOnInit(): void {
    this.googleAnalyticsService.sendPageView('Authentication: Error', '/authenticate/error');
    this.route.data.subscribe(
      (data: IData) => {
        if (data && data.error) {
          if (typeof data.error.errorMessage == "string") {
              this.errorMessage = data.error.errorMessage;
          }

          if (typeof data.error.origin == "string") {
            this.retryUrl = data.error.origin;
          }
        }
      }
    )
  }

}
